import {Dropzone} from "dropzone";

// Disable auto-discover to prevent automatic initialization
Dropzone.autoDiscover = false;

function initializeDropzone(element) {
    console.log('Attempting to initialize dropzone on element:', element);

    // Check if dropzone already exists on this element
    if(element.dropzone) {
        console.log('Dropzone already exists on element, returning existing instance');
        return element.dropzone;
    }

    try {
        const dropzone = new Dropzone(element, {
            url: "/attachment/upload",
            clickable: true, // Make the dropzone clickable
            maxFiles: 10,
            maxFilesize: 10, // MB
            addRemoveLinks: true,
            dictRemoveFileConfirmation: "Are you sure you wish to permanently remove this attachment?",
            accept: function(file, done) {
                done();
            },
            removedfile: function(file) {
                // Try to get ticket ID and type from this specific dropzone's inputs
                let ticket = $(element).find('.attachment-id-input').val();
                let type = $(element).find('.attachment-type-input').val();

                // Fallback to page-level inputs if not found in dropzone
                if(!ticket) {
                    ticket = $("#ticket-id").val() || $("#attachmentId").val();
                }
                if(!type) {
                    type = $("#attachmentType").val() || "tickets";
                }

                console.log('Removing file:', {
                    name: file.name,
                    ticket: ticket,
                    type: type
                });

                var name = file.name;

                if(!ticket || !type) {
                    console.error('Missing required fields for file removal:', {
                        ticket: ticket,
                        type: type
                    });
                    alert('Error: Cannot remove file - missing ticket or type information');
                    return;
                }

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });
                $.ajax({
                    type: 'POST',
                    url: '/attachment/remove',
                    data: {
                        name: name,
                        type: type,
                        id: ticket  // Backend expects 'id', not 'ticket'
                    },
                    success: function(data) {
                        console.log('File removed successfully');
                    },
                    error: function(xhr, status, error) {
                        console.error('Error removing file:', xhr.responseJSON);
                        alert('Error removing file: ' + (xhr.responseJSON?.message || error));
                    }
                });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            }
        });

        // Add click event to debug
        element.addEventListener('click', function(e) {
            console.log('Dropzone clicked!', e.target);
        });

        dropzone.on('addedfile', function(file) {
            console.log('File added to dropzone:', file.name);

            var ext = file.name.split('.').pop();

            if(ext === "pdf") {
                $(file.previewElement).find(".dz-image img").attr("src", "/storage/pdf.png");
            } else if(ext.indexOf("doc") !== -1) {
                $(file.previewElement).find(".dz-image img").attr("src", "/storage/word.png");
            } else if(ext.indexOf("xls") !== -1) {
                $(file.previewElement).find(".dz-image img").attr("src", "/storage/excel.png");
            }
            /*// Add a link to download the image
             $(".dz-remove").before("<a href=''>Download</a><br/>");*/
        });
        dropzone.on("error", function(file, message) {
            console.error('Dropzone upload error:', message);
        });

        console.log('Dropzone initialized successfully on element:', element);

        // Handle pre-existing attachments (not managed by dropzone)
        // These are attachments loaded from the server that don't have Dropzone file objects
        $(element).find('.dz-preview[data-attachment-id]').each(function() {
            const $preview = $(this);
            const attachmentId = $preview.attr('data-attachment-id');
            const $removeBtn = $preview.find('.dz-remove');

            // Add click handler for the remove button
            $removeBtn.on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                if(!confirm("Are you sure you wish to permanently remove this attachment?")) {
                    return;
                }

                // Get attachment name from the preview
                const attachmentName = $preview.find('[data-dz-name]').text();

                // Get ticket ID and type from dropzone's inputs
                let ticket = $(element).find('.attachment-id-input').val();
                let type = $(element).find('.attachment-type-input').val();

                // Fallback to page-level inputs
                if(!ticket) {
                    ticket = $("#ticket-id").val() || $("#attachmentId").val();
                }
                if(!type) {
                    type = $("#attachmentType").val() || "tickets";
                }

                console.log('Removing pre-existing file:', {
                    name: attachmentName,
                    ticket: ticket,
                    type: type,
                    attachmentId: attachmentId
                });

                if(!ticket || !type) {
                    console.error('Missing required fields for file removal:', {
                        ticket: ticket,
                        type: type
                    });
                    alert('Error: Cannot remove file - missing ticket or type information');
                    return;
                }

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.ajax({
                    type: 'POST',
                    url: '/attachment/remove',
                    data: {
                        name: attachmentName,
                        type: type,
                        id: ticket
                    },
                    success: function(data) {
                        console.log('Pre-existing file removed successfully');
                        $preview.fadeOut(300, function() {
                            $(this).remove();
                        });
                    },
                    error: function(xhr, status, error) {
                        console.error('Error removing file:', xhr.responseJSON);
                        alert('Error removing file: ' + (xhr.responseJSON?.message || error));
                    }
                });
            });
        });

        return dropzone;
    } catch(error) {
        console.error('Error initializing dropzone:', error);
        return null;
    }
}

// Initialize dropzones on page load
const $ = window.jQuery || window.$;

if($) {
    $(document).ready(function() {
        // Specifically target FORM elements with dropzone class
        const dropzoneElements = $('form.dropzone');
        console.log('Page load: Found ' + dropzoneElements.length + ' dropzone form elements');

        // Only initialize dropzones that are NOT inside a modal
        // Modals will initialize their dropzones when shown
        dropzoneElements.each(function(index) {
            const $this = $(this);
            const isInsideModal = $this.closest('.modal').length > 0;
            const dropzoneId = $this.attr('data-dropzone-id');
            const isModalDropzone = dropzoneId && dropzoneId.startsWith('modal-');

            console.log(`Dropzone form ${index}:`, {
                id: this.id,
                tagName: this.tagName,
                dropzoneId: dropzoneId,
                isInsideModal: isInsideModal,
                isModalDropzone: isModalDropzone,
                willInitialize: !isInsideModal && !isModalDropzone
            });

            // Skip only if inside modal OR specifically marked as a modal dropzone
            if(!isInsideModal && !isModalDropzone) {
                initializeDropzone(this);
            }
        });
    });

    // Note: Modal-specific initialization is handled in each modal's own JavaScript
    // because dropzone elements may not be properly nested in the modal DOM structure
} else {
    console.error('jQuery is not available for dropzone initialization');
}

// Export the function so it can be called manually if needed
window.initializeDropzone = initializeDropzone;

